
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        organization: formData.organization,
        message: formData.message
      }).toString();

      const response = await fetch('https://readdy.ai/api/form/d5padmkue1sdfststir0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', organization: '', message: '' });
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 5000);
      }
    } catch (error) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 5000);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="bg-[#0C0C0C] py-20 sm:py-28 md:py-32 lg:py-40">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-[32px] sm:text-[42px] md:text-[56px] lg:text-[64px] font-bold text-[#F5F5F5] leading-tight mb-4 sm:mb-6 font-serif">
            To Ensure Discretion,<br />Access Is By Introduction Only
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#909090] max-w-[640px] mx-auto px-4 sm:px-0">
            To discuss engagement, contact us through your family office or advisory team.
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="name" className="block text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-[#707070] mb-2 sm:mb-3">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-transparent border-b border-[#303030] text-sm sm:text-[15px] text-[#F5F5F5] py-2 sm:py-3 focus:outline-none focus:border-[#606060] transition-colors"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-[#707070] mb-2 sm:mb-3">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-transparent border-b border-[#303030] text-sm sm:text-[15px] text-[#F5F5F5] py-2 sm:py-3 focus:outline-none focus:border-[#606060] transition-colors"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div>
              <label htmlFor="organization" className="block text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-[#707070] mb-2 sm:mb-3">
                Organization / Family Office
              </label>
              <input
                type="text"
                id="organization"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                required
                className="w-full bg-transparent border-b border-[#303030] text-sm sm:text-[15px] text-[#F5F5F5] py-2 sm:py-3 focus:outline-none focus:border-[#606060] transition-colors"
                placeholder="Your organization"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-[#707070] mb-2 sm:mb-3">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={500}
                rows={5}
                className="w-full bg-transparent border border-[#303030] rounded-lg text-sm sm:text-[15px] text-[#F5F5F5] p-3 sm:p-4 focus:outline-none focus:border-[#606060] transition-colors resize-none"
                placeholder="Describe your requirements (max 500 characters)"
              />
              <div className="text-right text-[10px] sm:text-[11px] text-[#505050] mt-2">
                {formData.message.length}/500
              </div>
            </div>

            <button
              type="submit"
              disabled={status === 'submitting'}
              className="w-full bg-[#1C1410] border border-[#404040] hover:bg-[#2A1F18] hover:border-[#606060] rounded-full py-4 sm:py-5 text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-white transition-all duration-200 flex items-center justify-center gap-2 sm:gap-3 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'submitting' ? 'Submitting...' : 'Initiate Contact'}
              <i className="ri-arrow-right-line text-sm sm:text-base"></i>
            </button>

            {status === 'success' && (
              <div className="text-center text-xs sm:text-sm text-green-400 mt-4">
                Message received. We will contact you through secure channels.
              </div>
            )}

            {status === 'error' && (
              <div className="text-center text-xs sm:text-sm text-red-400 mt-4">
                Submission failed. Please try again or contact us directly.
              </div>
            )}
          </form>
        </div>

        <div className="mt-16 sm:mt-24 md:mt-32 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 lg:gap-10">
          {[
            {
              image: 'https://public.readdy.ai/ai/img_res/ccd66e4c48737728206c84b630ad5068.jpg',
              alt: 'Private Aviation'
            },
            {
              image: 'https://readdy.ai/api/search-image?query=luxury-superyacht-deck-detail-with-elegant-teak-flooring-sophisticated-maritime-design-high-end-yacht-exterior-premium-nautical-craftsmanship&width=280&height=180&seq=visual002&orientation=landscape',
              alt: 'Maritime Operations'
            },
            {
              image: 'https://readdy.ai/api/search-image?query=elegant-estate-entrance-gate-with-sophisticated-architecture-luxury-property-entrance-high-end-residential-security-premium-estate-design&width=280&height=180&seq=visual003&orientation=landscape',
              alt: 'Estate Security'
            },
            {
              image: 'https://readdy.ai/api/search-image?query=professional-medical-equipment-case-in-luxury-setting-elite-emergency-medical-kit-sophisticated-medical-preparedness-high-end-medical-security-equipment&width=280&height=180&seq=visual004&orientation=landscape',
              alt: 'Medical Equipment'
            }
          ].map((item, index) => (
            <div
              key={index}
              className="w-full h-[120px] sm:h-[140px] md:h-[160px] lg:h-[180px] rounded-xl overflow-hidden shadow-2xl"
              style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.4)' }}
            >
              <img
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
